import React from "react";

import { Typography } from "@material-ui/core";
import { HashLink as Link } from "react-router-hash-link";

import { Button } from "semantic-ui-react";

import ReactGA from "react-ga";

import "./Banner.css";

const handleCTA = () => {

  window.open('https://wa.me/5511947509495', '_blank');
};

const Banner = () => (
  <div id="home" className="banner">
    <div className="banner-container">
       <Typography variant="h1" align="left" className="text titulo-banner">
        O cuidado que seu celular merece, no conforto da sua casa
      </Typography>
      <Typography variant="h2" align="left" className="subtitulo-banner">
        Faça seu orçamento grátis, online e instantâneo.
      </Typography>
      <Link to="#do-estimate">
        <Button
          content="Solicitar Orçamento"
          icon="dollar"
          labelPosition="right"
          className="button-banner"
          onClick={handleCTA}
        />
      </Link>
      <Typography variant="h2" align="left" className="subtitulo-banner">
        Serviço somente disponível para cidade de São Paulo
      </Typography>
    </div>
  </div>
);

export default Banner;
